import type { Post } from "@/types";
import React, { FC } from "react";
import { Image } from "../image";

export const PostAuthor: FC<{
  author: Post["author"];
}> = ({ author }) => {
  return (
    <section className="postAuthor">
      <div className="wrapper">
        <div className="postAuthor--inner">
          <div className="postAuthor--writer">
            {author.avatar && (
              <Image
                src={author.avatar}
                noInline
                alt={(author as any).avatar.title}
                className="postAuthor--avatar"
              />
            )}
            <div className="postAuthor--writtenBy">Written by</div>
            <div className="postAuthor--name">{author.fullName}</div>
          </div>
          <p className="postAuthor--description">{author.description}</p>
          <div className="postAuthor--bottom">
            {author.tags && author.tags.length > 0 && (
              <div className="postAuthor--tags">
                <div className="postAuthor--tags-title">Tags</div>
                <div className="postAuthor--tags-list">
                  {author.tags.map((tag, index) => (
                    <React.Fragment key={index}>
                      {index > 0 && ", "}
                      {tag}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            )}
            <div className="postAuthor--social">
              {author.facebook && (
                <a
                  href={author.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="postAuthor--social-item"
                >
                  <svg
                    width="10"
                    height="18"
                    viewBox="0 0 10 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      id="Vector"
                      d="M9.5 0H7.04545C5.96048 0 4.91994 0.474106 4.15274 1.31802C3.38555 2.16193 2.95455 3.30653 2.95455 4.5V7.2H0.5V10.8H2.95455V18H6.22727V10.8H8.68182L9.5 7.2H6.22727V4.5C6.22727 4.26131 6.31347 4.03239 6.46691 3.8636C6.62035 3.69482 6.82846 3.6 7.04545 3.6H9.5V0Z"
                      fill="#2F323A"
                    />
                  </svg>
                </a>
              )}
              {author.twitter && (
                <a
                  href={author.twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                  className="postAuthor--social-item"
                >
                  <svg
                    width="18"
                    height="14"
                    viewBox="0 0 18 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      id="Vector"
                      d="M18 0.00784565C17.2165 0.534866 16.349 0.937952 15.4309 1.20158C14.9382 0.661287 14.2833 0.278341 13.5548 0.104535C12.8264 -0.0692709 12.0596 -0.0255511 11.3581 0.229782C10.6565 0.485114 10.0542 0.93974 9.63244 1.53217C9.2107 2.1246 8.98993 2.82626 9 3.54224V4.32246C7.56215 4.35801 6.13741 4.05391 4.85264 3.43726C3.56788 2.8206 2.46299 1.91052 1.63636 0.788065C1.63636 0.788065 -1.63636 7.81003 5.72727 10.9309C4.04225 12.0216 2.03495 12.5685 0 12.4913C7.36364 16.3924 16.3636 12.4913 16.3636 3.51883C16.3629 3.3015 16.341 3.08471 16.2982 2.87125C17.1332 2.08595 17.7225 1.09447 18 0.00784565V0.00784565Z"
                      fill="#2F323A"
                    />
                  </svg>
                </a>
              )}
              {author.linkedIn && (
                <a
                  href={author.linkedIn}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Linked In"
                  className="postAuthor--social-item"
                >
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="Vector">
                      <path
                        d="M9.09999 5.14209C10.3992 5.14209 11.6453 5.65821 12.564 6.57692C13.4827 7.49563 13.9988 8.74166 13.9988 10.0409V15.7562H10.7329V10.0409C10.7329 9.60782 10.5609 9.19248 10.2546 8.88624C9.94841 8.58001 9.53307 8.40797 9.09999 8.40797C8.6669 8.40797 8.25156 8.58001 7.94533 8.88624C7.63909 9.19248 7.46705 9.60782 7.46705 10.0409V15.7562H4.20117V10.0409C4.20117 8.74166 4.7173 7.49563 5.636 6.57692C6.55471 5.65821 7.80074 5.14209 9.09999 5.14209Z"
                        fill="#2F323A"
                      />
                      <path
                        d="M3.26783 5.9585H0.00195312V15.7561H3.26783V5.9585Z"
                        fill="#2F323A"
                      />
                      <path
                        d="M1.63489 3.50953C2.53674 3.50953 3.26783 2.77844 3.26783 1.87659C3.26783 0.974744 2.53674 0.243652 1.63489 0.243652C0.733045 0.243652 0.00195312 0.974744 0.00195312 1.87659C0.00195312 2.77844 0.733045 3.50953 1.63489 3.50953Z"
                        fill="#2F323A"
                      />
                    </g>
                  </svg>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
